import React from 'react';
import { Stack, Grid, Box, IconButton } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomInputLabel, CustomDatePicker, InputProps, FlexDiv, } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import docStyles from './otherdoc.module.css';
import { AttachFile as AttachFileIcon, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DateFormat, MonthFormat } from 'custom/constants';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';

const ServiceLog = (props) => {
  const columns = [
    {
      accessorKey: 'type',
      header: 'Type',
      size: 80,
      cell: info => {
        const row = info.row.original;
        return row?.service_log?.type;
      },
    },
    {
      accessorKey: 'code',
      header: 'Airline',
      size: 100,
      cell: info => {
        const row = info.row.original;
        return row?.service_log?.airline?.code;
      },
    },
    {
      accessorKey: 'date',
      header: 'Date',
      size: 100,
      cell: info => {
        const row = info.row.original;
        return row?.service_log?.type == 'DAY'
          ? dayjs(row?.service_log?.date).format(DateFormat).toUpperCase()
          : dayjs(row?.service_log?.date).format(MonthFormat).toUpperCase();
      },
    },
    {
      id: 'action',
      header: <div className={`${styles.textCenter}`}>Action</div>,
      size: 100,
      enableSorting: false,
      enableColumnFilter: false,
      cell: info => {
        const row = info.row.original;
        return (
          <Stack
            direction='row'
            spacing={2}
            justifyContent='center'
            className={styles.actionIcons}
          >
            <div onClick={() => props.handlePopover('attached_docs', true, row)}>
              <AttachFileIcon
                fontSize='small'
                className={`${styles.pointer}`}
              />
            </div>
          </Stack>
        );
      },
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <StyledCard>
          <FlexDiv className={styles.mb3}><StyledCardTitle>Filter Service Logs Documents List</StyledCardTitle></FlexDiv>
          <Stack direction='row'>
            <Grid container spacing={2} columnSpacing={4}>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomInputLabel htmlFor='' aria-label='Enter from date'>From</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'From Date',
                      fullWidth: true
                    },
                  }}
                  className={styles.w100}
                  format='DD MMM YYYY'
                  name='from'
                  value={dayjs(props.searchOptions.from)}
                  // helperText={}
                  onChange={(e) => props.handleChange(e, 'from')}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomInputLabel htmlFor='' aria-label='Enter to date '>To</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'To Date',
                      fullWidth: true
                    },
                  }}
                  className={styles.w100}
                  format='DD MMM YYYY'
                  name='to'
                  value={dayjs(props.searchOptions.to)}
                  // helperText={}
                  onChange={(e) => props.handleChange(e, 'to')}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={8} className={styles.sqIconsContainer}>
                <CustomInputLabel className={styles.colorTransparent}>-</CustomInputLabel>
                <IconButton disableRipple onClick={() => props.search()} className={styles.p0}>
                  <Search fontSize='1.7rem' classes={{ root: `${styles.sqIcons} ${styles.mb0}` }} />
                </IconButton>
              </Grid>
            </Grid>
          </Stack>
        </StyledCard>
      </Grid>

      <Grid item xs={12}>
        <StyledCard className={styles.positionRelative}>
          <FlexDiv className={styles.mb4}><StyledCardTitle>Service Logs Documents</StyledCardTitle></FlexDiv>
          {/* <CustomSearch
              id='search'
              name='awb'
              value={props.filter.awb}
              variant='outlined'
              size='small'
              placeholder='Enter Name'
              onChange={props.onChangefilter}
              type='search'
              className={styles.brInput}
              InputProps={{
                endAdornment: <InputAdornment position='end'>
                  <IconButton
                    size='small'
                    aria-label='search'
                    edge='end'
                    onClick={() => props.onChangefilter({
                      target: {
                        name: 'awb_search',
                        value: '' 
                      } 
                    })}
                  >
                    <Search fontSize='inherit' />
                  </IconButton>
                </InputAdornment>,
              }}
              InputLabelProps={{ shrink: false }}
            /> */}
          <div className={styles.tableWrapper}>
            <Box className={`${styles.tableOuter} ${docStyles.docTableOuter}`}>
              <TableWrapper columns={columns} data={props.data} />
            </Box>
          </div>
        </StyledCard>
      </Grid>

    </Grid>
  );
};

export default ServiceLog;
